/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/orderManageself',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '自营-订单管理',
      icon: 'component',
    },
    children: [
      {
        path: '/orderManageself/orderList',
        component: () => import('@/myviews/shoppMall/orderManageself/orderList/orderList.vue'),
        alwaysShow: false,
        name: 'OrderListself',
        meta: {
          title: '订单管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/refundOrderManage/refundOrderList',
        component: () => import('@/myviews/refundOrderManage/refundOrderList'),
        name: 'refundOrderList',
        meta: {
          title: '退款订单管理',
          icon: 'component',
          alwaysShow: false,
          roles: [],
          have: [],
        }
      },
      {
        path: '/orderManageself/prescriptionOrderList',
        component: () => import('@/myviews/shoppMall/orderManageself/prescriptionOrderList/prescriptionOrderList.vue'),
        alwaysShow: false,
        name: 'prescriptionOrderList',
        meta: {
          title: '处方单管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/orderManageself/chronicDiseaseOrderList',
        component: () => import('@/myviews/shoppMall/orderManageself/chronicDiseaseOrderList/chronicDiseaseOrderList.vue'),
        alwaysShow: false,
        name: 'chronicDiseaseOrderList',
        meta: {
          title: '慢病处方单管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/orderManageself/orderDetail',
        component: () => import('@/myviews/shoppMall/orderManageself/orderDetail/orderDetail.vue'),
        alwaysShow: false,
        hidden: true,
        name: 'OrderDetailself',
        meta: {
          title: '订单详情',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/orderManageself/orderDetailnew',
        component: () => import('@/myviews/shoppMall/orderManageself/orderDetail/orderDetailnew.vue'),
        alwaysShow: false,
        hidden: true,
        name: 'orderDetailnewself',
        meta: {
          title: '自营订单详情',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/orderManageself/prescriptionOrderDetail',
        component: () => import('@/myviews/shoppMall/orderManageself/prescriptionOrderList/prescriptionOrderDetail.vue'),
        alwaysShow: false,
        hidden: true,
        name: 'prescriptionOrderDetail',
        meta: {
          title: '处方单详情',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
    ]
  },
  {
    path: '/refundOrderManage/refundOrderManage',
    component: Layout,
    notShow: true,
    meta: {
      title: '商城退款订单详情',
      icon: 'component'
    },
    children: [{
      path: '/refundOrderDetail',
      component: () => import('@/myviews/refundOrderManage/refundOrderDetail.vue'),
      name: 'refundOrderDetail',
      meta: {
        title: '商城退款订单详情',
        icon: 'component',
        alwaysShow: true
      }
    }]
  }
]



// WEBPACK FOOTER //
// ./src/router/shoppMall/orderManageself.js